import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FileElement } from 'src/app/models/FileElement';
import { FligthInspectionAerodata, FligthInspectionCSV } from 'src/app/models/flight-inspection';
import { NavaidModel } from 'src/app/models/navaid';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import {  ConfigureFlightInpectionFormatComponent } from '../../configure-flight-inpection-format/configure-flight-inpection-format.component';
import { ConfigureProcessingToolFormatComponent } from '../../configure-processing-tool-format/configure-processing-tool-format.component';
import { ProcessingToolOptionsComponent } from '../../processing-tool-options/processing-tool-options.component';
import { UserSpaceLimitWarningMessage } from 'src/app/models/error';
import { UserSettingsService } from 'src/app/services/userSettings.service';
import { ProjectService } from 'src/app/services/project.service';

@Component({
  selector: 'app-flight-inspection',
  templateUrl: './flight-inspection.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class FlightInspectionComponent implements OnInit {

  decimate : boolean = false;
  @Input()
  fileFormat: string;

  @Input()
  file: File;
  @Input() fileName: string;
  @Input() importConfig: any;
  @Input() defaultConfig: any;

  @Input() layerName: string;
  config: boolean =false;

  navaid: NavaidModel;

  @Input() isProcessingTool: boolean;

  selectedChannelIndex: number = 0;

  constructor(
    private modalService: ModalControlService,
    public bsModalRef : BsModalRef,
    public popupService: BsModalService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    public pointsService: PointsService,
    private uiBlock: UiBlockService,
    public userSettingsService: UserSettingsService,
    private projectService: ProjectService
  ) { }

  ngOnInit(): void {
  }

  cancelflightInspectionImport():void {
    this.bsModalRef.hide();
  }

  openConfigureFormat(){
    const bsRef: BsModalRef = this.popupService.show(ConfigureFlightInpectionFormatComponent);
    bsRef.content.importConfig = this.importConfig;
    bsRef.content.fileFormat = this.fileFormat;
    bsRef.content.onClose.subscribe((result) =>{
      this.importConfig = result;
      this.config = true;
    })
  }

  openPTConfigureFormat(){
    const bsRef: BsModalRef = this.popupService.show(ConfigureProcessingToolFormatComponent);
    bsRef.content.importConfig = this.importConfig;
    bsRef.content.defaultConfig = this.defaultConfig;
    bsRef.content.fileFormat = this.fileFormat;
    bsRef.content.selectedChannelIndex = this.selectedChannelIndex;
    bsRef.content.onClose.subscribe((result) =>{
      this.importConfig = result[0];
      this.defaultConfig = result[1];
      this.navaid = result[2] as NavaidModel;
      this.selectedChannelIndex = result[3];
      this.config = true;
    })
  }

  ok(){
    const projectId = this.projectService.activeProject.id;
    const formData: FormData = new FormData();
    this.importConfig.layerName = this.layerName;
    formData.append('file', this.file, this.fileName);
    formData.append('config', JSON.stringify(this.importConfig));
    this.uiBlock.startBlock("Importing Flight Inspection ...")
    this.http.post(
      this.endpointService.endpointAddFlightInspection + "/"+ this.fileFormat,
      formData,
      {
      ...this.endpointService.httpOptions,
      params: { projectId: projectId }
      }
    ).subscribe((data:any)=>{
        let flightInspection :any = JSON.parse(data.flightinspectionstr);
        flightInspection.id = data.id;
        this.pointsService.addFlightInspectionToMap(flightInspection);
        this.userSettingsService.createNewVisibilityLayer('Flight Inspections',""+ flightInspection.id);
        this.bsModalRef.hide();
        this.uiBlock.stopBlock();
    },
    (error) => {
      this.bsModalRef.hide();
      this.uiBlock.stopBlock();
      if (error && error.status == 401) {
        this.modalService.showMesssageModal(
          'Error Deleting',
          'Default Project is not editable.'
        )
        return;
      }
      if (error && error.status == 507) {
        this.modalService.showMesssageModal("Warning",UserSpaceLimitWarningMessage);
        this.pointsService.deleteFlightInspectionsFromMap();
        this.pointsService.fetchAndAddFlightInspection();
        return;
      }
      this.modalService.showMesssageModal("Error", "File format error.");
    }
    )
  }

  performOkProcessingTool(){
    this.bsModalRef.hide();
    const bsRef = this.popupService.show(ProcessingToolOptionsComponent);
    bsRef.content.file = this.file;
    bsRef.content.fileName = this.fileName;
    bsRef.content.fileFormat = this.fileFormat;
    bsRef.content.importConfig = this.importConfig;
    bsRef.content.defaultConfig = this.defaultConfig;
    bsRef.content.navaid = this.pointsService.getNavaidPayload(this.navaid);
    bsRef.content.navaid.usesectorization = this.navaid.usesectorization;
    bsRef.content.layerName = this.layerName;
  }
}
